// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Playfair_Display_e97de2', '__Playfair_Display_Fallback_e97de2'"},"className":"__className_e97de2"};